import React, {Component} from "react";
import { inject, observer } from 'mobx-react';
import { Table, Button, Input, FormGroup } from "reactstrap";

import { timezones, dateAndTime } from "./dummyData";
import Select from "react-select";

@inject('generalSettingsStore', 'configurationStore')
@observer
class General extends Component {
  constructor(props) {
    super(props);
    this.state={};
  }

  componentDidMount = () => {
    const { generalSettingsStore } = this.props;
    generalSettingsStore.getGeneralSettings();
  }

  handleSave = () => {
    const { generalSettingsStore } = this.props;
    // generalSettingsStore.saveGeneralSettings();
  }

  render() {
    const { generalSettingsStore } = this.props;
    const { languages, brandText, brandImage, language, dateTimeFormat, timezone } = generalSettingsStore;
    const brandTextVal = brandText[Object.keys(brandText)[0]]?.value;
    const brandImageVal = brandImage[Object.keys(brandImage)[0]]?.value;
    const languageVal = language[Object.keys(language)[0]]?.name;
    const dateTimeFormatVal = dateTimeFormat[Object.keys(dateTimeFormat)[0]]?.value;
    const timezoneVal = timezone[Object.keys(timezone)[0]]?.value;
    const languageOptions = languages && languages.length ?
      languages.map((lang) => {
        return { value: lang.name, label: lang.name }
      }) : [];
    const selectedLanguageIndex = languageVal ? languageOptions.findIndex((lang) => lang.name === languageVal) : null;
    return(
      <div className="general">
        <Table borderless>
          <tbody>
            <tr>
              <td><b>Branding Text:</b></td>
              <td className="value">
                <FormGroup>
                  <Input 
                    type="text"
                    name="brandText"
                    placeholder="Branding Text"
                    defaultValue={brandTextVal}
                  />
                </FormGroup>
              </td>
            </tr>
            <tr>
              <td><b>Brand Logo:</b></td>
              <td className="value">
                {
                  brandImageVal
                    ? <img style={{ height: "40px", width: "auto" }} src={brandImageVal} alt="logo" />
                    : <img style={{ height: "40px", width: "auto" }} src={require("../../../assets/img/logo/logo-primary.png")} alt="logo" />
                }
                <Button
                  className="btn ml-3 btn-sm"
                  color="primary"
                >
                  Change Logo
                </Button>
              </td>
            </tr>
            <tr>
              <td><b>Time Zone:</b></td>
              <td className="value">
                <FormGroup>
                  <Select
                    className="React"
                    classNamePrefix="select"
                    placeholder="Select Time Zone"
                    // defaultValue={}
                    name="clear"
                    options={timezones}
                    isClearable={true}
                  />
                </FormGroup>
              </td>
            </tr>
            <tr>
              <td><b>Date and Time Format:</b></td>
              <td className="value">
                <FormGroup>
                  <Select
                    className="React"
                    classNamePrefix="select"
                    placeholder="Date and Time Format"
                    // defaultValue={}
                    name="clear"
                    options={dateAndTime}
                    isClearable={true}
                  />
                </FormGroup>
              </td>
            </tr>
            <tr>
              <td><b>Language:</b></td>
              <td className="value">
                <FormGroup>
                  <Select
                    className="React"
                    classNamePrefix="select"
                    placeholder="Select Language"
                    value={languageOptions[selectedLanguageIndex]}
                    name="language"
                    options={languageOptions}
                    isClearable={true}
                  />
                </FormGroup>
              </td>
            </tr>
          </tbody>
        </Table>
        <div className="mt-4 text-right">
          <Button
            className="btn"
            color="primary"
            onClick={this.handleSave}
          >
            Save
          </Button>
        </div>
      </div>
    );
  }
}

export default General;